/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { AUTOGRADERSTUDENTFEEDBACKInput } from './autograderStudentFeedbackInput';
import type { PltStudentComment } from './pltStudentComment';
import type { PltBusinessStudentComment } from './pltBusinessStudentComment';
import type { LegacyRemark } from './legacyRemark';
import type { SubmissionFeedbackFeedbackAnyOf } from './submissionFeedbackFeedbackAnyOf';

export type SubmissionFeedbackFeedback =
  | AUTOGRADERSTUDENTFEEDBACKInput
  | PltStudentComment
  | PltBusinessStudentComment
  | LegacyRemark
  | SubmissionFeedbackFeedbackAnyOf
  | null;
